import { EntryStatusApi, } from 'api-typings/contests/contests';
export var CONTEST_ENTRY_IMAGE_FORMATS = [
    'jpeg',
    'jpg',
    'png',
    'gif',
];
export var CONTEST_ENTRY_VIDEO_FORMATS = [
    'mov',
    'mpg',
    'mpeg',
    'avi',
    'flv',
];
export var CONTEST_ENTRY_AWARD_STATUSES = [
    EntryStatusApi.WON,
    EntryStatusApi.WON_CLOSED,
    EntryStatusApi.WON_RUNNER_UP,
    EntryStatusApi.WON_BRONZE,
    EntryStatusApi.WON_SILVER,
    EntryStatusApi.WON_GOLD,
    EntryStatusApi.CHOSEN,
];
/** Set of contest entry statuses allowed to be shown in CVP */
export var VISIBLE_ENTRIES_DEFAULT_FILTER = [
    EntryStatusApi.WITHDRAWN,
    EntryStatusApi.WITHDRAWN_ELIMINATED,
    EntryStatusApi.ELIMINATED,
    EntryStatusApi.ACTIVE,
    EntryStatusApi.BOUGHT
].concat(CONTEST_ENTRY_AWARD_STATUSES);
